import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c3a7578e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a7578e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xinyushan/sdYuShan/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3a7578e')) {
      api.createRecord('c3a7578e', component.options)
    } else {
      api.reload('c3a7578e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c3a7578e&scoped=true&", function () {
      api.rerender('c3a7578e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/balanceConfig/index.vue"
export default component.exports